import React from 'react';
import { connect } from 'react-redux';
import PromiseCreator from 'promise-creator';
import PropTypes from 'prop-types';
import Modal from '../Modal';
import PositionTypeMissingForm from './PositionTypeMissingForm';
import { changeUserInfoAction } from '../../redux/me';
import { STUDENT_VIEW } from '../../redux/app';
import SITE_MODES from '../../../constants/site-modes';
import styles from './PositionTypeMissing.css';

const PositionTypeMissing = ({
    show,
    changeUserInfo,
}) => {
    if (!show) {
        return null;
    }

    return (<Modal
        open
        className={styles.modal}
    >
        <h2>Nice Work!</h2>
        <p>
            We need a few more pieces of information before you get started on the assessments:
        </p>
        <PositionTypeMissingForm
            onSubmit={({ positionType, companyPositions }) => {
                const { resolve, reject, promise } = PromiseCreator();
                changeUserInfo({
                    resolve,
                    reject,
                    positionType,
                    companyPositions,
                });
                return promise;
            }}
        />
    </Modal>);
};

PositionTypeMissing.propTypes = {
    changeUserInfo: PropTypes.func,
    show: PropTypes.bool,
};

export default connect(({ me, theme, app }) => ({
    show: (me && !me.positionType
        && theme.siteMode === SITE_MODES.EMPLOYER
        && app.view === STUDENT_VIEW),
}), {
    changeUserInfo: changeUserInfoAction,
})(PositionTypeMissing);



// WEBPACK FOOTER //
// ./src/client/Components/PositionTypeMissing/PositionTypeMissing.js